export default __webpack_public_path__ + "static/media/polaroid05.33cf5e6f.jpg";